<div mat-dialog-content class="confirm-dialog">
  <mat-icon class="success-icon">check_circle</mat-icon>
  <h3 mat-dialog-title>
    {{ 'CUSTOMER_FACING_FORM.CONFIRM_DIALOG_TITLE' | translate }}
  </h3>
  <span class="description">
    {{ 'CUSTOMER_FACING_FORM.CONFIRM_DIALOG_DESC_1' | translate }}
  </span>
  <span class="description">
    {{
      (templateType === TEMPLATE_TYPE_SMS
        ? 'CUSTOMER_FACING_FORM.CONFIRM_SMS_DIALOG_DESC_2'
        : 'CUSTOMER_FACING_FORM.CONFIRM_EMAIL_DIALOG_DESC_2'
      ) | translate
    }}
  </span>
  <button
    class="close-button"
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
  >
    {{ 'CUSTOMER_FACING_FORM.CONFIRM_DIALOG_BUTTON' | translate }}
  </button>
</div>
